module.exports = __webpack_public_path__ + "static/media/ALTHAR_telemedicina.af27a2a9.png";